import { ExerciseDraft } from "./exerciseDraft";

export function isExerciseValid(ex: ExerciseDraft): boolean {
	return !!ex.title && !ex.choices.find((c) => !c.text) && !!ex.choices.find((c) => !!c.valid);
}
